<template lang="pug">
#preencher-contrato-originacao
    BaseHeader(
        titulo='Preencher contrato de originação',
        :exibeBotao='false',
        :voltarPara='true'
    )

    .view-container.margen-bottom-pages
        .bloco-dados-contrato-originacao
            BlocoDadosContratoOriginacao(v-if='contratoOriginacao', :dados='contratoOriginacao')

        .bloco-inserir-dados-contrato-originacao
            BlocoInserirDadosManual(
                @atualizar-lista='atualizarListaTerritorios'
            )
            BlocoInserirDadosPlanilha

        .bloco-listagem-territorio-contrato
            TabelaListagemTerritorioContrato(
                ref='refTabelaListagemTerritorioContrato'
            )

        //- .bloco-view-container-down
        //-     el-link.bloco-view-container-down__conteudo__remove-item(
        //-         icon='el-icon-delete',
        //-         @click='irParaContrato()'
        //-     ) Remover item

        //-     .bloco-view-container-down__conteudo__buttons
        //-         el-button(
        //-             icon='el-icon-circle-plus-outline',
        //-             @click='salvarListaTerritorio'
        //-         ) Salvar lista de território

        //-         el-button(
        //-             type='primary',
        //-             icon='el-icon-plus',
        //-             @click='realizarAnaliseSocioambiental'
        //-         ) Realizar análise socioambiental
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoDadosContratoOriginacao from '@/components/contratosOriginacao/BlocoDadosContratoOriginacao';
import BlocoInserirDadosManual from '@/components/contratosOriginacao/BlocoInserirDadosManual.vue';
import BlocoInserirDadosPlanilha from '@/components/contratosOriginacao/BlocoInserirDadosPlanilha.vue';
import TabelaListagemTerritorioContrato from '@/components/contratosOriginacao/TabelaListagemTerritorioContrato.vue';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'PreencherContratoOriginacao',
    components: {
        BaseHeader,
        BlocoDadosContratoOriginacao,
        BlocoInserirDadosManual,
        BlocoInserirDadosPlanilha,
        TabelaListagemTerritorioContrato
    },
    data() {
        return {
            contratoOriginacao: null
        };
    },

    mounted() {
        this.buscarDadosGerais();
    },

    methods: {
        atualizarListaTerritorios() {
            this.$refs.refTabelaListagemTerritorioContrato.buscarDadosContratos();
        },

        irParaContrato() {
            this.$router.push({ name: 'Home' });
        },
        buscarDadosGerais() {
            try {
                ContratoOriginacaoService.dadosContratoSubempresa(
                    this.$route.params.numeroContrato
                ).then(({ data }) => {
                    this.contratoOriginacao = data;
                });
            } catch (error) {
                this.$notify.error({
                    message:
                        'Erro na requisição de buscar dados gerais.'
                });
            }
        }
    }
};
</script>

<style lang="scss">
#preencher-contrato-originacao {
    .bloco-dados-contrato-originacao,
    .bloco-inserir-dados-contrato-originacao,
    .bloco-listagem-territorio-contrato,
    .bloco-view-container-down {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
    }

    .bloco-inserir-dados-contrato-originacao {
        justify-content: space-between;
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        flex-direction: row;

        .el-card__body {
            align-items: stretch;
        }
    }

    .bloco-view-container-down {
        gap: 15px;
        width: 100%;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;

        .bloco-view-container-down__conteudo__remove-item {
            el-link {
                color: var(--hover-danger);
            }
        }

        .bloco-view-container-down__conteudo__buttons {
            display: flex;
            gap: 10px;
        }
    }
}
</style>
